import { SVC_A } from './base'

export function getLongClip (cameraId, start, end) {
  return SVC_A.get(`/api/v4/long_clips/${cameraId}?token=YAT&start=${start}&end=${end}&mode=link`)
}
